import React from 'react';
import { deadlineFrom } from '../shared/deadlines';

// "N days" + calendar/business picker shown next to a deadline date. The Effective Date is day 0.
// Values live on the form as {name}Days and {name}DayMode; the parent recomputes the date (applyDeadlineDays).
export default function DeadlineDays({ name, values, effectiveDate, onChange, inputStyle }) {
  const days = values[`${name}Days`] ?? '';
  const mode = values[`${name}DayMode`] || 'calendar';
  const r = days !== '' ? deadlineFrom(effectiveDate, days, mode) : null;
  const small = { ...(inputStyle || {}), width: 'auto', minWidth: 0 };
  return (
    <div style={{ marginTop: 6 }}>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <input type="number" min="0" inputMode="numeric" placeholder="days" aria-label="Days after the Effective Date" value={days}
          onChange={(e) => onChange(name, e.target.value.replace(/\D/g, ''), mode)} style={{ ...small, width: 90 }} />
        <select aria-label="Day type" value={mode} onChange={(e) => onChange(name, days, e.target.value)} style={small}>
          <option value="calendar">calendar days</option>
          <option value="business">business days</option>
        </select>
      </div>
      {days !== '' && (
        <div style={{ fontSize: 12, color: '#9a9a9a', marginTop: 4 }}>
          {!effectiveDate ? 'Enter the Under Contract (Effective) Date to count days.'
            : r ? `${days} ${mode} days after the Effective Date (day 0)${r.rolled ? `; ${r.landedOn} is a ${r.reason}, so it moves to the next business day` : ''}.` : ''}
        </div>
      )}
    </div>
  );
}

// Recompute every deadline that has a day count (call after the Effective Date or a day count changes).
export const applyDeadlineDays = (values, fields, effectiveKey) => {
  const out = { ...values };
  fields.forEach((k) => {
    const d = out[`${k}Days`];
    if (d === '' || d == null) return;
    const r = deadlineFrom(out[effectiveKey], d, out[`${k}DayMode`] || 'calendar');
    if (r) out[k] = r.date;
  });
  return out;
};
